import "core-js/modules/web.dom-collections.iterator.js";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import heightControlsImage from "../../../../wwwroot/images/height-controls.svg";
import mouseControlsImage from "../../../../wwwroot/images/mouse-control.svg";
import wasdControlsImage from "../../../../wwwroot/images/wasd.svg";
import Box from "../../../Styled/Box";
import Button from "../../../Styled/Button";
import Icon, { StyledIcon } from "../../../Styled/Icon";
import Spacing from "../../../Styled/Spacing";
import Text from "../../../Styled/Text";
import MovementsController from "./MovementsController";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const MovementControls = props => {
  const [isMaximized, setIsMaximized] = useState(true);
  const [t] = useTranslation();
  const toggleMaximized = () => setIsMaximized(!isMaximized);
  useEffect(() => {
    const movementsController = new MovementsController(props.cesium, props.onMove, props.pedestrianHeight, props.maxVerticalLookAngle);
    const detach = movementsController.activate();
    return detach;
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [props.cesium]);
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs(Title, {
      children: [/*#__PURE__*/_jsx(Text, {
        medium: true,
        children: t("pedestrianMode.controls.title")
      }), /*#__PURE__*/_jsx(MinimizeMaximizeButton, {
        onClick: toggleMaximized,
        maximized: isMaximized
      })]
    }), isMaximized && /*#__PURE__*/_jsxs(Body, {
      children: [/*#__PURE__*/_jsx("img", {
        alt: "Mouse controls",
        src: mouseControlsImage
      }), /*#__PURE__*/_jsx("img", {
        alt: "Direction controls",
        src: wasdControlsImage
      }), /*#__PURE__*/_jsx(Spacing, {
        bottom: 1
      }), /*#__PURE__*/_jsx("img", {
        alt: "Height controls",
        src: heightControlsImage
      })]
    })]
  });
};
const backgroundColor = "#ffffff";
const Container = styled.div.withConfig({
  displayName: "MovementControls__Container",
  componentId: "sc-1epy31h-0"
})(["background-color:", ";box-shadow:0 4px 8px 4px rgb(0 0 0 / 5%);border-radius:3px;"], backgroundColor);
const Title = styled(Box).attrs({
  medium: true
}).withConfig({
  displayName: "MovementControls__Title",
  componentId: "sc-1epy31h-1"
})(["justify-content:space-between;align-items:center;padding:0 0.5em;border-bottom:1px solid #c0c0c0;"]);
const MinimizeMaximizeButton = styled(Button).attrs(_ref => {
  let {
    maximized
  } = _ref;
  return {
    renderIcon: () => /*#__PURE__*/_jsx(ButtonIcon, {
      glyph: maximized ? Icon.GLYPHS.minimize : Icon.GLYPHS.maximize
    })
  };
}).withConfig({
  displayName: "MovementControls__MinimizeMaximizeButton",
  componentId: "sc-1epy31h-2"
})(["padding:0;margin:0;border:0;background-color:", ";"], backgroundColor);
const ButtonIcon = styled(StyledIcon).withConfig({
  displayName: "MovementControls__ButtonIcon",
  componentId: "sc-1epy31h-3"
})(["height:20px;"]);
const Body = styled(Box).attrs({
  column: true,
  centered: true
}).withConfig({
  displayName: "MovementControls__Body",
  componentId: "sc-1epy31h-4"
})(["align-items:center;margin-top:1em;& img{padding-bottom:1em;}"]);
export default MovementControls;